// set basepath of project for webpack
import { basePath } from './core/config'
__webpack_public_path__ = `${basePath}/assets/iti/js/`

import './core/Sentry'

// nette
import './nette/NetteAutosubmit'
import './nette/NetteValidationMessages'
import Nette from './nette/NetteForms'
window.Nette = Nette
Nette.reinit()
window.addEventListener('naja:afterupdate', () => {
	EventBus.emit(EVENTS.DOM_CHANGE)
	Nette.reinit()
})
window.addEventListener('modal:load', () => Nette.reinit())
Nette.initOnLoad()

import NajaService from './services/Naja'
NajaService.initialize()
NajaService.formsHandler.netteForms = Nette

import TouchMouseInputResolver from './meta/TouchMouseInputResolver'
new TouchMouseInputResolver()

import ScrollService, { scrollToElement } from './services/Scroll'
ScrollService.useNative()

import { loadComponents, removeComponents } from './core/componentUtils'
loadComponents()

import { watchLazyImages } from './utils/lazyImages'
watchLazyImages()

import { CMS } from './core/config'
import Swup from 'swup-v4'
import EventBus from './core/EventBus'
import { EVENTS } from './core/Events'

if (!CMS && !document.body.classList.contains('u-swup-disabled')) {
	const swup = new Swup({
		linkSelector: [
			'a[href^="' + window.location.origin + '"]:not([data-no-swup]):not([target="_blank"]):not(.ajax):not([download])',
			'a[href^="/"]:not([data-no-swup]):not([target="_blank"]):not(.ajax):not([download])',
		].join(', '),
		animationSelector: '.Swup',
		containers: ['#swup', '#modals', '#footer'],
		skipPopStateHandling: (event)=> {
			if (event.state?.source === 'swup') {
				return false
			}
			return true
		}
	})

	swup.hooks.on('link:self', (visit) => {
		if (visit.trigger.el?.dataset?.forceSamePage !== undefined) {
			scrollToElement(document.querySelector('.Page'))
		}
	})

	swup.hooks.on('scroll:anchor', () => {
		console.log('scrolling')
		return true
	})

	swup.hooks.on('link:click', (event) => {
		EventBus.emit(EVENTS.SWUP_CLICK_LINK, { event })
	})

	swup.hooks.on('visit:start', (visit) => {
		const els = [...document.querySelectorAll(visit.containers.join(','))] 
		els.forEach((element) => {
			removeComponents(element)
		})
	})

	swup.hooks.on('content:replace', (visit) => {
		Nette.reinit()

		const els = [...document.querySelectorAll(visit.containers.join(','))] 
		els.forEach((element) => {
			loadComponents(element)
		})

		ScrollService.resize()
		EventBus.emit(EVENTS.SWUP_CONTENT_REPLACED)
	})
}
